export default __webpack_public_path__ + "static/media/page1-img_07.e63de164.jpg";